import { ThemeProvider, ThemeOptions, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'

import Routes from './pages/routes'
import { GoogleAnalytics } from './scenes/index'
import { parameter } from './utils/resources'

const darkTheme: ThemeOptions = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: parameter("palette.primary.main") as string,
      light: parameter("palette.primary.light") as string,
      dark: parameter("palette.primary.dark") as string,
      contrastText: parameter("palette.primary.contrastText") as string
    },
    secondary: {
      main: parameter("palette.secondary.main") as string,
      light: parameter("palette.secondary.light") as string,
      dark: parameter("palette.secondary.dark") as string,
      contrastText: parameter("palette.secondary.contrastText") as string
    },
    success: {
      main: '#016126',
      light: '#338051',
      dark: '#00431A',
      contrastText: '#FFFFFF'
    },
    error: {
      main: '#941511',
      light: '#A94340',
      dark: '#670E0B',
      contrastText: '#FFFFFF'
    },
    warning: {
      main: '#FFCA28',
      light: '#FFD453',
      dark: '#B28D1C',
      contrastText: '#000000'
    },
    info: {
      main: '#4fc3f7',
      light: '#72CFF8',
      dark: '#3788AC',
      contrastText: '#000000'
    },
    background: {
      default: '#F9F9F9',
      paper: '#FFFFFF',
    }
  },
  shadows: [
    'none',
    '0px 5px 5px -3px rgba(0,0,0,0.1)',
    '0px 10px 10px -3px rgba(0,0,0,0.1)',
    '0px 15px 15px -3px rgba(0,0,0,0.1)',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none'
  ],
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'inherit',
          fontWeight: 400
        }
      },
      defaultProps: {
        disableElevation: true,
        variant: 'contained'
      }
    }
  }
})

const App = () => {
  return (
      <ThemeProvider theme={darkTheme}>
        <GoogleAnalytics />
        <CssBaseline />
        <Routes />
      </ThemeProvider>
  )
}

export default App
